import env                      from '../env';
import {
    UserSession,
    Recipient,
    CommcontrollerPayload
}                               from '../types';
import { createCacheableFetch } from '../helpers/fetchTools';

const cachedFetch = createCacheableFetch();

type RecipientPayload = CommcontrollerPayload<{
    conversation: {
        recipient: Recipient
    }
}>;

export default async function recipientService(session: UserSession, conversationId: number): Promise<RecipientPayload> {
    const requestInit: RequestInit = {
        method: 'GET',
        headers: new Headers({
            Authorization: `Bearer ${session.token}`
        }),
        mode: 'cors',
        cache: 'default',
    };

    return cachedFetch([`${env.MESSAGE_LIST_HOST}/v1/rest/conversations/${conversationId}`, requestInit]);
}



// WEBPACK FOOTER //
// ./src/services/RecipientService.ts